


import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

import {
  Form,
  Button,
  Alert,
  Spinner,
  Container,
  Row,
  Col,
  Card,
  Modal
} from 'react-bootstrap';



const API_IMAGE_URL = "https://apimyshop.myidealtd.co.uk";


const getImageUrl = (img) => {

    if (!img) {
        return "/no-image.png";
    }


    // Backend image object
    if (typeof img === "object") {

        img =
            img.main ||
            img.url ||
            img.path ||
            img.filename ||
            img.original ||
            "";

    }


    if (!img) {
        return "/no-image.png";
    }


    img = String(img);


    // Already full URL
    if (img.startsWith("http")) {
        return img;
    }


    // Remove starting slash
    img = img.replace(/^\/+/, "");


    return `${API_IMAGE_URL}/${img}`;

};


/* ================= LABEL COMPONENT ================= */

const LabelRow = ({ label, children }) => (
  <div className="d-flex align-items-center mb-3">

    <div
      style={{
        width: 150,
        fontWeight: 600,
        color: '#555'
      }}
    >
      {label}
    </div>


    <div style={{ flex: 1 }}>
      {children}
    </div>


  </div>
);



function EditProduct() {


const { id } = useParams();

const navigate = useNavigate();



/* ================= PRODUCT STATE ================= */


const [product, setProduct] = useState({

    name: '',

    brand: '',

    category: '',

    description: '',

    price: '',

    countInStock: '',

    images: [],


    // ==========================
    // Product Marketing Flags
    // ==========================



    featured: false,

    bestSeller: false,

    newArrival: false,

    onSale: false,

    trending: false

});



const [initialProduct, setInitialProduct] = useState(null);



const [images, setImages] = useState([]);



const [dragActive, setDragActive] = useState(false);



const [previewIndex, setPreviewIndex] = useState(null);



const [loading, setLoading] = useState(true);


const [error, setError] = useState('');


const [updating, setUpdating] = useState(false);



const [showModal, setShowModal] = useState(false);


const [modalText, setModalText] =
useState('Product Updated');





/* ================= FETCH PRODUCT ================= */


useEffect(() => {


const fetchProduct = async () => {


try {


const res = await axios.get(
`https://apimyshop.myidealtd.co.uk/api/products/${id}`
);



const data = res.data;

console.log("PRODUCT DATA =====>", data);
console.log("PRODUCT IMAGES =====>", data.images);

const normalized = {


name:
String(data.name || ''),



brand:
String(data.brand || ''),



category:
String(data.category || ''),



description:
String(data.description || ''),



price:
String(data.price || ''),



countInStock:
String(data.countInStock || ''),



images:
Array.isArray(data.images)
?
[...data.images]
:
[],




// =====================
// FLAGS FROM DATABASE
// =====================





featured:
data.featured || false,


bestSeller:
data.bestSeller || false,


newArrival:
data.newArrival || false,


onSale:
data.onSale || false,

trending:
Boolean(data.trending),



};





setProduct(normalized);



setInitialProduct(normalized);

setImages(
    (data.images || []).map(img => ({
        type: "existing",
        src: getImageUrl(img),
        data: img          // KEEP ORIGINAL IMAGE
    }))
);







}

catch(err){


console.error(err);


setError(
'Error fetching product.'
);


}


finally{


setLoading(false);


}


};



fetchProduct();



},[id]);

/* ================= INPUT HANDLER ================= */


const handleChange = (e) => {

const { name, value } = e.target;


setProduct(prev => ({

...prev,

[name]: value

}));

};




/* ================= CHECKBOX HANDLER ================= */


const handleCheckbox = (field) => {


setProduct(prev => ({


...prev,


[field]: !prev[field]


}));

};





/* ================= IMAGE UPLOAD ================= */


const handleFiles = (files) => {


const remaining =
3 - images.length;


const selected =
Array.from(files)
.slice(0, remaining);




const newImages =
selected.map(file => ({


type:'new',


src:URL.createObjectURL(file),


file


}));



setImages(prev => [

...prev,

...newImages

]);


};





const handleImageChange = (e)=>{


handleFiles(
e.target.files
);


};






/* ================= DRAG EVENTS ================= */


const handleDrag = (e)=>{


e.preventDefault();

e.stopPropagation();


setDragActive(

e.type === 'dragenter' ||
e.type === 'dragover'

);


};





const handleDrop = (e)=>{


e.preventDefault();

e.stopPropagation();


setDragActive(false);


handleFiles(
e.dataTransfer.files
);


};





/* ================= REMOVE IMAGE ================= */


const removeImage = (index)=>{


const updated =
[...images];


updated.splice(index,1);


setImages(updated);


};






/* ================= CHECK CHANGES ================= */



const isSameProduct = useCallback(() => {
    if (!initialProduct) return false;

    const sameFields =
        product.name === initialProduct.name &&
        product.brand === initialProduct.brand &&
        product.category === initialProduct.category &&
        product.description === initialProduct.description &&
        product.price === initialProduct.price &&
        product.countInStock === initialProduct.countInStock &&
        product.featured === initialProduct.featured &&
        product.bestSeller === initialProduct.bestSeller &&
        product.newArrival === initialProduct.newArrival &&
        product.onSale === initialProduct.onSale &&
        product.trending === initialProduct.trending;

    const currentExistingImages = images
        .filter(img => img.type === "existing")
        .map(img => img.src);

    const initialExistingImages = (initialProduct.images || []).map(img =>
        getImageUrl(img)
    );

    const sameImages =
        JSON.stringify(currentExistingImages) ===
        JSON.stringify(initialExistingImages);

    // Detect newly added images
    const hasNewImages = images.some(img => img.type === "new");

    return sameFields && sameImages && !hasNewImages;
}, [product, images, initialProduct]);






/* ================= UPDATE PRODUCT ================= */


const handleUpdate = async ()=>{


setUpdating(true);


setError('');



try{



if(isSameProduct()){


setModalText(
'No changes detected'
);


setShowModal(true);



setTimeout(()=>{


setShowModal(false);


navigate(
'/productlist',
{
replace:true
}
);


},1500);



return;


}






const formData = new FormData();





/* PRODUCT FIELDS */


Object.entries(product)

.forEach(([key,value])=>{


if(
key !== 'images' &&
key !== 'active'
){

formData.append(
key,
value
);

}


});






/* EXISTING IMAGES */


/* EXISTING IMAGES */


const existingImages = images
.filter(
    i => i.type === "existing"
)
.map(
    i => i.data
);





formData.append(

'existingImages',

JSON.stringify(existingImages)

);






/* NEW IMAGES */


images.forEach(img=>{


if(img.type==='new'){


formData.append(

'photos',

img.file

);


}



});






await axios.put(

`https://apimyshop.myidealtd.co.uk/api/products/update/${id}`,

formData,

{
headers:{
"Content-Type":"multipart/form-data"
},
withCredentials:true
}

);





setModalText(
'Product Updated'
);


setShowModal(true);




setTimeout(()=>{


setShowModal(false);


navigate(
'/productlist',
{
replace:true
}
);


},1500);



}


catch(err){


console.error(err);


setError(

err.response?.data?.message ||

'Error updating product'

);


}


finally{


setUpdating(false);


}



};






/* ================= LOADING ================= */


if(loading){


return (

<div

className="d-flex justify-content-center align-items-center"

style={{
height:'60vh'
}}

>

<Spinner animation="border"/>

</div>

);


}

return (

<Container
className="py-5"
style={{
maxWidth:1200
}}
>


<h2 className="fw-bold mb-4">
Edit Product
</h2>



{
error &&
<Alert variant="danger">
{error}
</Alert>
}




<Form>


<Row className="g-4">



{/* ================= LEFT SIDE ================= */}


<Col md={6}>


<Card
className="p-4 border-0 shadow-sm rounded-4"
>


<h5 className="mb-4">
Product Details
</h5>




<LabelRow label="Name">

<Form.Control

name="name"

value={product.name}

onChange={handleChange}

/>

</LabelRow>





<LabelRow label="Brand">

<Form.Control

name="brand"

value={product.brand}

onChange={handleChange}

/>

</LabelRow>





<LabelRow label="Category">

<Form.Control

name="category"

value={product.category}

onChange={handleChange}

/>

</LabelRow>





<LabelRow label="Price">


<Form.Control

type="number"

name="price"

value={product.price}

onChange={handleChange}

/>


</LabelRow>





<LabelRow label="Stock">


<Form.Control

type="number"

name="countInStock"

value={product.countInStock}

onChange={handleChange}

/>


</LabelRow>






<LabelRow label="Description">


<Form.Control

as="textarea"

rows={4}

name="description"

value={product.description}

onChange={handleChange}

/>


</LabelRow>





<hr/>





<h5 className="mb-3">
Product Status
</h5>


<Form.Check

type="checkbox"

label="New Arrival"

checked={product?.newArrival || false}

onChange={()=>handleCheckbox('newArrival')}

/>





<Form.Check

type="checkbox"

label="Featured Product"

checked={product?.featured || false}

onChange={()=>handleCheckbox('featured')}

/>





<Form.Check

type="checkbox"

label="Best Seller"

checked={product?.bestSeller || false}

onChange={()=>handleCheckbox('bestSeller')}

/>





<Form.Check

type="checkbox"

label="On Sale"

checked={product?.onSale || false}

onChange={()=>handleCheckbox('onSale')}

/>











</Card>


</Col>






{/* ================= RIGHT SIDE IMAGES ================= */}



<Col md={6}>


<Card

className="p-4 border-0 shadow-sm rounded-4"

>


<div

className="d-flex justify-content-between mb-3"

>

<h5>
Product Images
</h5>


<span className="text-muted">

{images.length}/3

</span>


</div>







<div

className="d-flex flex-wrap gap-3 mb-4"

>


{

images.map((img,index)=>(


<div

key={index}

style={{
width:130
}}

>


<img

src={img.src}

onError={(e)=>{
    e.target.src="/no-image.png";
}}

style={{

width:130,

height:120,

objectFit:'cover',

borderRadius:15,

cursor:'pointer'

}}

/>




<div className="text-center mt-2">


<Button

size="sm"

variant="outline-danger"

onClick={()=>removeImage(index)}

>

Remove

</Button>



</div>


</div>



))


}





</div>







<div

onDragEnter={handleDrag}

onDragOver={handleDrag}

onDragLeave={handleDrag}

onDrop={handleDrop}


style={{

border:

dragActive

?

'2px solid #0d6efd'

:

'2px dashed #ccc',


padding:30,

borderRadius:20,

textAlign:'center'

}}

>


<h6>
Drag & Drop Images
</h6>


<p className="text-muted">

or select files

</p>




<Form.Control

type="file"

multiple

accept="image/*"

onChange={handleImageChange}

/>


</div>




</Card>


</Col>



</Row>





<div

className="text-end mt-4"

>


<Button

size="lg"

disabled={updating}

onClick={handleUpdate}

>


{

updating

?

"Updating..."

:

"Save Changes"

}


</Button>



</div>




</Form>






<Modal

show={showModal}

centered

>

<Modal.Body

className="text-center p-4"

>


<h5>

{modalText}

</h5>


<small className="text-muted">

Redirecting...

</small>



</Modal.Body>


</Modal>



</Container>

);


}


export default EditProduct;